const responsiveSizes = {
  desktop: 992,
  tablet: 768,
  phone: 576,
};

export default responsiveSizes;
